export enum OrderHistoryRecordType {
	Modified = "MODIFIED"
}
